import ImageCompressor from 'image-compressor.js'

const compressor = {}

compressor.image = function(file) {
  return new Promise((reslove, reject) => {
    new ImageCompressor(file, {
      quality: 0.6,
      maxHeight: 1280,
      success(result) {
        console.log(result)
        console.log(result.name)
        reslove(result)
      },
      error(error) {
        console.log(error.message)
        reject(error.message)
      }
    })
  })
}

export default compressor
